var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerNode flex"},[_c('div',{ref:"worldMap",staticClass:"world"})])
}
var staticRenderFns = []

export { render, staticRenderFns }